/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CasesToToursAssignListRequest } from '../../models/cases-to-tours-assign-list-request';
import { TourListResponse } from '../../models/tour-list-response';

export interface AssociateCasesWithTours$Params {
      body: CasesToToursAssignListRequest
}

export function associateCasesWithTours(http: HttpClient, rootUrl: string, params: AssociateCasesWithTours$Params, context?: HttpContext): Observable<StrictHttpResponse<TourListResponse>> {
  const rb = new RequestBuilder(rootUrl, associateCasesWithTours.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TourListResponse>;
    })
  );
}

associateCasesWithTours.PATH = '/api/v1/tours/associated_cases';
